import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth'; 

const adminRoutes = [];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/idrc',
      name: 'idrc',
      component: () => import('../views/IdRCView.vue'),
    },
    {
      path: '/idrc-sucesso',
      name: 'idrc-sucesso',
      component: () => import('../views/IdRCSucessoView.vue'),
    },
    {
      path: '/bootstrap',
      name: 'bootstrap',
      component: () => import('../views/BootstrapView.vue'),
    },
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue'),
    },
    {
      path: "/detalhe-registro/:tipo_registro/:id",
      name: "DetalheRegistro",
      component: () => import("../views/DetalheRegistroView.vue"),
      props: {
        default: true,
      },
    },
    {
      path: '/nivel-baixo',
      name: 'nivel-baixo',
      component: () => import('../views/nivelDeGarantia/NivelBaixoView.vue'),
    },
    {
      path: '/nivel-baixo',
      name: 'nivel-baixo',
      component: () => import('../views/nivelDeGarantia/NivelBaixoView.vue'),
    },
    {
      path: '/nivel-substancial',
      name: 'nivel-substancial',
      component: () => import('../views/nivelDeGarantia/NivelSubstancialView.vue'),
    },
    {
      path: '/nivel-alto',
      name: 'nivel-alto',
      component: () => import('../views/nivelDeGarantia/NivelAltoView.vue'),
    },

    ...adminRoutes.map((item) => {
      item.path = '/admin' + item.path;
      return item;
    }),
  ],
});

router.beforeEach(async (to) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/bootstrap', '/sem-acesso', '/idrc', '/idrc-sucesso'];
  const authRequired = !publicPages.includes(to.path);
  const auth = useAuthStore();
  const { logout } = to.query;

  if (logout) {
    await auth.logoutCallback();
    return '/';
  } 

  if (auth.user || authRequired) {
    const authenticated = await auth.verifyLogin();

    if (!authenticated) {
      auth.logoutCallback();
      window.location.href = `${import.meta.env.VITE_REDIRECT_URL}`;
    }

    if (to.path === '/nivel-baixo') await auth.ensureLOA('baixo');
    if (to.path === '/nivel-substancial') await auth.ensureLOA('substancial');
    if (to.path === '/nivel-alto') await auth.ensureLOA('alto');

    if (to.path.includes('/admin') && !auth.user.isAdmin) {
      return '/';
    }
  }
});

export default router;
